import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Header = ({ notification, error, clearError, onLogout, children }) => {
  const { t } = useTranslation();
  
  return (
    <header className="dashboard-header">
      <div className="header-title">
        <h1>{t('app.title')}</h1>
      </div>
      
      <div className="notifications-area">
        {error && (
          <div className="error-notification">
            <span>{error}</span>
            <button onClick={clearError} className="close-btn">×</button>
          </div>
        )}
        
        {notification && (
          <div className={`success-notification ${notification.isThreshold ? 'threshold-notification' : ''}`}>
            <span>{notification.message}</span>
            {notification.isThreshold && (
              <span className="threshold-badge">Reward Milestone!</span>
            )}
          </div>
        )}
      </div>
      
      <div className="header-actions">
        <div className="date-display">
          {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' })}
        </div>
        
        {/* Add logout button */}
        <button onClick={onLogout} className="logout-button">
          <span className="logout-icon">⏻</span>
          <span className="logout-text">خروج</span>
        </button>
      </div>
    </header>
  );
};

export default Header;